import { Component, Input, Output, EventEmitter } from "@angular/core";

import {ContextMenu} from "./icontextmenu.component"

@Component({
  selector: "table-context-menu",
  templateUrl: "./context-menu.component.html",
  styleUrls: ["./context-menu.component.scss"],
})
export class TableContextMenuComponent {
  @Input()
  contextMenuItems: Array<ContextMenu>;

  @Output()
  onContextMenuItemClick: EventEmitter<any> = new EventEmitter<any>();

  onContextMenuClick(event, data): any {
    this.onContextMenuItemClick.emit({
      event,
      data,
    });
  }
}
